import { forwardRef, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { accountInfo, text } from '../../Constants'
import { InfoCard } from '../info-card/InfoCard'
import './AccountInformationView.scss'
import { EditModeAccountInformationView } from './edit-mode-account-information-view/EditModeAccountInformationView'

export const AccountInformationView = forwardRef(
  (
    {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      isEditMode,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setIsEditMode,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      accountInfoData,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      isCheckNumberInProgress,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setIsCheckNumberInProgress,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setAccountInfoData,
    },
    ref,
  ) => {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('id')

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo[id] || {})

    const accountData = useMemo(() => accountInfo(patientInfo, text.PERSONAL), [patientInfo])
    const contactData = useMemo(() => accountInfo(patientInfo, text.CONTACT), [patientInfo])
    const emergencyContactData = useMemo(() => accountInfo(patientInfo, text.EMERGENCY_CONTACT), [patientInfo])

    if (isEditMode) {
      return (
        <EditModeAccountInformationView
          ref={ref}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          setAccountInfoData={setAccountInfoData}
          setIsEditMode={setIsEditMode}
          accountInfoData={accountInfoData}
          isCheckNumberInProgress={isCheckNumberInProgress}
          setIsCheckNumberInProgress={setIsCheckNumberInProgress}
        />
      )
    }

    return (
      <>
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <InfoCard title={text.PERSONAL} info={accountData} id='AccountInfoCard' />
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <InfoCard title={text.CONTACT} info={contactData} id='AccountInfoCardContact' isTooltipOutside />
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <InfoCard
          title={text.EMERGENCY_CONTACT}
          info={emergencyContactData}
          id='AccountInfoCardEmergencyContact'
          isTooltipOutside
        />
      </>
    )
  },
)
